const gallery = document.querySelectorAll('.gallery-content, .how-steps');
const prevBtn = document.querySelector('.gallery-btn.prev');
const nextBtn = document.querySelector('.gallery-btn.next');

nextBtn.addEventListener('click', () => {
  // Перебираємо кожен елемент у списку gallery
  gallery.forEach(item => {
    item.scrollBy({ left: 320, behavior: 'smooth' });
  });
});

prevBtn.addEventListener('click', () => {
  gallery.forEach(item => {
    item.scrollBy({ left: -320, behavior: 'smooth' });
  });
});
